import { Injectable } from '@angular/core';
import { FirebaseService } from './firebase.service';
import { FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';

@Injectable()
export class ColorShadeService {
	private db;
	colorShade: FirebaseListObservable<ColorShade[]>;

	constructor(private firebaseService: FirebaseService) {
		this.db = firebaseService.db;
		this.loadColorShade();
	}

	/**
	 * Load initial data
	 */
	loadColorShade() {
		window.dispatchEvent(new Event('loading'));
		this.colorShade = this.db.list('/color-shade') as FirebaseListObservable<ColorShade[]>
		this.colorShade.subscribe(data => {
			this.triggerDataChange();
		});

		return this.colorShade;
	}

	triggerDataChange() {
		window.dispatchEvent(new Event('data-loaded'));
	}

	/**
	 * Get All Tonalities
	 */
	getColorShades() {
		return this.colorShade;
	}

	/**
	 * Get Tonality by ID
	 * @param {string} id : Item ID
	 */
	getColorShade(id:string) {
		return this.db.object('/color-shade/'+id) as FirebaseObjectObservable<ColorShade>;
	}

	/**
	 * Add new Tonality
	 * @param {colorShade} tonality
	 */
	addColorShade(colorShade) {
		return this.colorShade.push(colorShade);
	}

	/**
	 * Update Tonality Data
	 * @param {string} id   : Item ID
	 * @param {object} data : Updated data
	 */
	updateColorShade(id:string, data:ColorShade) {
		var tonality = this.getColorShade(id);
		data.updated_at = (new Date()).getTime();
		return tonality.update(data);
	}

	/**
	 * Delete Tonality
	 * @param {string} id : Item ID
	 */
	deleteColorShade(id:string) {
		var promise = new Promise<any>((resolve, reject) => {
			if(!id){
				reject('ID must provided.');
			}
			else
			{
				var result = this.colorShade.remove(id).then(data => {
					this.triggerDataChange();
					resolve(data);
				})
			}
		})
		return promise;
	}
}

export class ColorShade {
	$key?:string;
	name?:string = '';
	color?:string = '#ffffff';

	created_at?:number;
	updated_at?:number;

	constructor()
	{
		var now = new Date();
		this.created_at = now.getTime();
		this.updated_at = now.getTime();
	}
}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/services/color-shade.service.ts